@if (updatedGroupList) {
<div class="col th-p group-details">
  <!--<div class="content-wrapper  is-clearfix">-->
  <header class="top-box-shadow">
    <div class="chats" style="width: 100%">
      <div class="content-wrapper is-clearfix">
        <div class="chat-name">
          <figure class="has-text-centered hideMobileView">
            <i
              class="fa is-pulled-left"
              [ngClass]="{
                'fa-angle-double-left': !this.groupComponent.viewSecondPanel,
                'fa-angle-double-right': this.groupComponent.viewSecondPanel
              }"
              (click)="hideSecondPanel()"
            ></i>
          </figure>
          <div class="is-pulled-left">
            @if (!updatedGroupList.group_icon) {
            <empty-uname
              [userName]="updatedGroupList.chat_group_name"
              [detailHeadProfile]="true"
            ></empty-uname>
            } @if (updatedGroupList.group_icon) {
            <img
              [src]="profileUrl + updatedGroupList.group_icon"
              class="is-pulled-left"
            />
            }
            <span class="chat-title-name hideMobileView is-size-6 mar-5-0">{{
              updatedGroupList.chat_group_name
            }}</span>
          </div>
          <div class="is-marginless is-clearfix is-pulled-right">
            <div class="is-pulled-right mar-10-0">
              <a
                class="is-small pad-10 tooltip has-tooltip-left"
                data-tooltip="Delete Lessonroom"
                (click)="removeGroupDetail(ind)"
              >
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="contents is-marginless">
    <div class="scroll-bar">
      <div class="column">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="columns new-chat mar-top15">
              <div class="column">
                <div class="card">
                  <div class="card-content">
                    <div class="content form-style">
                      <form [formGroup]="newGroupForm" novalidate>
                        <h3>Group</h3>
                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <div class="control profile-img">
                                @if (!updatedGroupList.chat_group_icon) {
                                <empty-uname
                                  [userName]="updatedGroupList.chat_group_name"
                                  [detailProfile]="true"
                                ></empty-uname>
                                } @if (updatedGroupList.chat_group_icon) {
                                <img
                                  [src]="
                                    profileUrl +
                                    updatedGroupList.chat_group_icon
                                  "
                                />
                                }
                                <span class="img-options">
                                  <div class="dropdown is-hoverable">
                                    <div class="dropdown-trigger">
                                      <i class="fa fa-camera"></i>
                                    </div>
                                    <div
                                      class="dropdown-menu"
                                      id="dropdown-menu4"
                                      role="menu"
                                    >
                                      <div class="dropdown-content">
                                        <a class="dropdown-item">
                                          <label class="file-label">
                                            <input
                                              class="file-input"
                                              name="profile"
                                              id="profile"
                                              type="file"
                                              (change)="onFileChange($event)"
                                              [disabled]="
                                                selectedFileList.length > 0
                                              "
                                              #fileInput
                                              accept=".jpg, .jpeg, .png, .svg"
                                            />
                                            <span class="file-label"
                                              >Update Picture</span
                                            >
                                          </label>
                                        </a>
                                        @if (updatedGroupList.chat_group_icon) {
                                        <a
                                          class="dropdown-item"
                                          (click)="deleteGroupProfile()"
                                          >Remove Picture</a
                                        >
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-12">
                            <div class="field">
                              <label class="label"
                                >Title
                                <span class="required">*</span>
                              </label>
                              <div class="control">
                                <input
                                  class="input"
                                  type="text"
                                  placeholder=""
                                  formControlName="chat_group_name"
                                />
                                <form-validation
                                  [control]="
                                    newGroupForm.controls.chat_group_name
                                  "
                                ></form-validation>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="column is-6">
                            <div class="field">
                              <label class="label">Privacy</label>
                              <div class="control">
                                <div class="select is-fullwidth">
                                  <select formControlName="is_private">
                                    <option value>--Select--</option>
                                    <option *ngFor="let privacy of privacyList" value="{{privacy.value}}">{{privacy.name}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label">Description</label>
                              <div class="control">
                                <textarea
                                  class="textarea"
                                  placeholder=""
                                  formControlName="chat_description"
                                  rows="2"
                                  (keydown)="keyDownHandler($event)"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-8">
                            <h4
                              data-tooltip="List of users who are already added to this class"
                            >
                              Users
                            </h4>
                          </div>
                          <div
                            class="column is-4"
                            style="position: relative; right: -14px"
                          >
                            <button
                              type="button"
                              class="button is-small is-link"
                              [disabled]="!newGroupForm.valid"
                              (click)="openAddUserSection()"
                            >
                              Add More Users
                            </button>
                            @if (selectedIdList.length > 0) {
                            <p class="display-ib mar-10-0">
                              <em>
                                {{ selectedIdList.length }} User selected
                              </em>
                            </p>
                            }
                          </div>
                        </div>
                        <div class="columns activeGroupUser">
                          <div class="column">
                            <div class="field pos-relative scroll-bar">
                              <div
                                class="panel pos-relative scroll-bar"
                                infinite-scroll
                                [infiniteScrollDistance]="modalScrollDistance"
                                [infiniteScrollThrottle]="modalScrollThrottle"
                                [scrollWindow]="false"
                                (scrolled)="onScrollDown()"
                              >
                                @for (user of userList; track user) {
                                <div
                                  class="existing_student"
                                  [ngClass]="{
                                    is_adminUser: user.is_group_admin
                                  }"
                                >
                                  <label
                                    class="panel-block pos-relative groupUserList"
                                    [ngClass]="{
                                      'active-bg':
                                        userIdList.indexOf(user.user_id) > -1
                                    }"
                                  >
                                    <div class="chat-user-status">
                                      @if (!user.user_icon) {
                                      <empty-uname
                                        [userName]="user.full_name"
                                        [liProfile]="true"
                                      ></empty-uname>
                                      } @if (user.user_icon) {
                                      <img
                                        [src]="profileUrl + user.user_icon"
                                        class="image is-48x48"
                                      />
                                      }
                                    </div>
                                    <div class="mar-0-10">
                                      <span class="display-b is-capitalized">
                                        {{ user.full_name }}</span
                                      >
                                      <!-- <p class="is-size-7 has-text-success" *ngIf="user.is_online">online</p> -->
                                      @if (user.is_online) {
                                      <p
                                        class="is-size-7"
                                        [ngClass]="{
                                          'circle-grey': user.user_status === 0,
                                          'circle-green':
                                            user.user_status === 1,
                                          'circle-red': user.user_status === 2,
                                          'circle-yellow':
                                            user.user_status === 3
                                        }"
                                      >
                                        {{ user.status_name }}
                                      </p>
                                      } @if (!user.is_online) {
                                      <p class="is-size-7 text-clr-grey">
                                        {{ user.last_seen | amTimeAgo }}
                                      </p>
                                      } @if (user.is_group_admin) {
                                      <a
                                        class="button is-primary is-outlined is-small time-ago"
                                        style="font-size: 10px; margin: 5px"
                                        >Admin</a
                                      >
                                      }
                                    </div>
                                    @if (userIdList.indexOf(user.user_id) > -1)
                                    {
                                    <span
                                      class="icon is-small icon-align is-pulled-right"
                                    >
                                      <i class="fa fa-check"></i>
                                    </span>
                                    } @if (!user.is_group_admin) {
                                    <a
                                      class="icon is-small icon-align is-pulled-right delete-user has-tooltip-left"
                                      (click)="deleteGroupUser(user.user_id)"
                                      data-tooltip="Remove User"
                                    >
                                      <i
                                        class="fa fa-trash"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                    }
                                  </label>
                                </div>
                                }
                                <pagination-loader
                                  [showFetchLoader]="showPaginateSpinner"
                                ></pagination-loader>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns display-flex is-clearfix">
                          <div class="column is-12">
                            <div class="has-text-right">
                              <button
                                class="button mar-0-5 is-small"
                                (click)="hideEditGroup()"
                              >
                                Cancel
                              </button>
                              <button
                                class="button is-link is-small"
                                [disabled]="
                                  (newGroupForm.valid && !newGroupForm.dirty) ||
                                  newGroupForm.invalid
                                "
                                (click)="updateGroupDetail(newGroupForm.value)"
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- User list modal -->
<div
  class="modalMobileView modal"
  [ngClass]="{ 'is-active': toggleModalSection }"
>
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <h4 style="font-weight: 700">Select More Users</h4>
      <h6 style="position: absolute; left: 17px; top: 28px; font-size: 13px">
        (Please select users you would like to add it to this policy)
      </h6>
    </div>
    <section class="modal-card-body">
      <div class="content">
        <div class="columns">
          <div class="column">
            <div class="field">
              <div class="panel-block">
                <p class="control has-icons-left">
                  <input
                    class="input is-small"
                    type="text"
                    placeholder="search"
                    [(ngModel)]="searchText"
                    (keyup)="searchInList.next($event)"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-search"></i>
                  </span>
                </p>
                @if (searchText) {
                <span
                  class="icon is-small is-right search-return"
                  style="position: relative; right: -5px; top: -9px"
                  (click)="showSearchbox('close')"
                >
                  <i class="fa fa-times-circle"></i>
                </span>
                }
              </div>

              <div
                class="panel panel-overflow scroll-bar"
                infinite-scroll
                [infiniteScrollDistance]="modalScrollDistance"
                [infiniteScrollThrottle]="modalScrollThrottle"
                [scrollWindow]="false"
                (scrolled)="onScrollDown()"
              >
                @for (user of listOfUsers; track user; let ind = $index) {
                <label
                  class="panel-block pos-relative"
                  (click)="selectUserId(ind, user)"
                >
                  <span class="image is-32x32 mar-0-10">
                    @if (!user.user_icon) {
                    <empty-uname
                      [userName]="user.full_name"
                      [detailHeadProfile]="true"
                    ></empty-uname>
                    } @if (user.user_icon && !user.is_group_admin) {
                    <img [src]="profileUrl + user.user_icon" />
                    }
                  </span>
                  {{ user.full_name }}
                  <!-- <span *ngIf="user.is_group_admin">Admin</span> -->
                  @if (user.is_selected && !user.is_group_admin) {
                  <span class="icon is-small icon-align is-pulled-right">
                    <i class="fa fa-check"></i>
                  </span>
                  }
                </label>
                }
                <pagination-loader
                  [showFetchLoader]="showPaginateSpinner"
                ></pagination-loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal-card-foot">
      <div class="column">
        <button type="button" class="button" (click)="clearAddUserSection()">
          Clear
        </button>
      </div>

      <div class="column has-text-right">
        <button
          type="button"
          class="button is-right mar-0-10"
          (click)="closeAddUserSection()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="button is-link is-right"
          (click)="openAddUserSection()"
        >
          Add
        </button>
      </div>
    </div>
  </div>
</div>
